import React from 'react';
import { Zap, Flame } from 'lucide-react';

/**
 * Sélecteur de type d'énergie (Électricité / Gaz)
 */
const EnergyTypeSelector = ({ energyType, setEnergyType }) => {
  return (
    <section className="card energy-selector-card" data-testid="energy-selector-section">
      <h2 className="section-title">Type d'Énergie</h2>
      <div className="energy-toggle-container">
        <button
          className={`energy-toggle-btn ${energyType === 'electricity' ? 'active' : ''}`}
          onClick={() => setEnergyType('electricity')}
          data-testid="energy-electricity-btn"
        >
          <Zap size={24} />
          <span>Électricité</span>
        </button>
        <button
          className={`energy-toggle-btn gas ${energyType === 'gas' ? 'active' : ''}`}
          onClick={() => setEnergyType('gas')}
          data-testid="energy-gas-btn"
        >
          <Flame size={24} />
          <span>Gaz</span>
        </button>
      </div>
    </section>
  );
};

export default EnergyTypeSelector;
